import React, { memo } from 'react'
import { formatCurrencyValue } from 'src/libs/qb-brand-web-components'
import { Box, Card, Divider, ListItemText, Stack } from '@mui/material'

import { LOYALIZE_API } from '../../constants/api'
import SubmitButton from '../shared/button/SubmitButton'
import { Image } from '../image'
import { Label } from '../label'

const CashbackBrandCard = ({
  t,
  id,
  name,
  description,
  commission,
  imageUrl,
  trackingUrl,
  onCashbackShopNowClick
}) => {
  return (
    id && (
      <Card>
        <Box sx={{ p: 3, pb: 2 }}>
          <Image
            src={imageUrl || `${LOYALIZE_API}${id}/logo`}
            slotProps={{
              img: {
                loading: 'lazy',
                sx: {
                  objectFit: 'contain'
                }
              }
            }}
            sx={{
              borderRadius: 2,
              width: 160,
              height: 90,
              mb: 2,
              backgroundColor: 'common.white',
              p: 1.5
            }}
          />

          <ListItemText
            sx={{ mb: 1 }}
            primary={name}
            secondary={description}
            slotProps={{
              primary: { sx: { typography: 'subtitle1' } },
              secondary: {
                sx: {
                  mt: 1,
                  typography: 'caption',
                  color: 'text.disabled',
                  display: '-webkit-box',
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden'
                }
              }
            }}
          />

          <Label variant='soft' color='primary' sx={{ width: 'fit-content' }}>
            {t('cashback.get-up-to-back', {
              cashbackAmount: commission
                ? `${formatCurrencyValue(commission.value, 2)}${commission.format}`
                : 0
            })}
          </Label>
        </Box>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <Stack
          sx={{
            p: 3,
            alignItems: 'flex-end'
          }}
        >
          <SubmitButton
            label={t('cashback.shop-now')}
            onClick={() => onCashbackShopNowClick(trackingUrl)}
            // size='default'
            type='button'
          />
        </Stack>
      </Card>
    )
  )
}

export default memo(CashbackBrandCard)
